import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapsPage from './pages/MapsPage/MapsPage';
import './App.css';

function App() {
  return (
    <Router basename='/'>
      <Routes>
        {/* Directions state with optional location */}
        <Route path="/:business_id/:map_id/:map_view_id/:floor/directions/:start_content_placement_id/:end_content_placement_id/:location" element={<MapsPage />} />
        <Route path="/:business_id/:map_id/:map_view_id/:floor/directions/:start_content_placement_id/:end_content_placement_id" element={<MapsPage />} />

        {/* Selected content state with optional location */}
        <Route path="/:business_id/:map_id/:map_view_id/:floor/selected-content/:content_placement_id/:location" element={<MapsPage />} />
        <Route path="/:business_id/:map_id/:map_view_id/:floor/selected-content/:content_placement_id" element={<MapsPage />} />

        {/* Search state with optional location */}
        <Route path="/:business_id/:map_id/:map_view_id/:floor/search/:query/:location" element={<MapsPage />} />
        <Route path="/:business_id/:map_id/:map_view_id/:floor/search/:query" element={<MapsPage />} />

        {/* Default state with optional location */}
        <Route path="/:business_id/:map_id/:map_view_id/:floor/:location" element={<MapsPage />} />
        <Route path="/:business_id/:map_id/:map_view_id/:floor" element={<MapsPage />} />










        <Route path="/:map_id/:map_view_id/directions/:start_content_placement_id/:end_content_placement_id/:floor_location" element={<MapsPage />} />
        <Route path="/:map_id/:map_view_id/directions/:start_content_placement_id/:end_content_placement_id" element={<MapsPage />} />

        {/* Selected content state with optional location */}
        <Route path="/:map_id/:map_view_id/selected-content/:content_placement_id/:floor_location" element={<MapsPage />} />
        <Route path="/:map_id/:map_view_id/selected-content/:content_placement_id" element={<MapsPage />} />

        {/* Search state with optional location */}
        <Route path="/:map_id/:map_view_id/search/:query/:floor_location" element={<MapsPage />} />
        <Route path="/:map_id/:map_view_id/search/:query" element={<MapsPage />} />

        <Route path="/:map_id/:map_view_id/setup" element={<MapsPage />} />

        <Route path="/:map_id/:map_view_id/:floor_location" element={<MapsPage />} />
        <Route path="/:map_id/:map_view_id" element={<MapsPage />} />
        <Route path="/:map_id" element={<MapsPage />} />

        {/* Fallback route for home */}
        <Route path="/" element={<div>Home Page</div>} />
      </Routes>
    </Router>
  );
}

export default App;